
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SchedulingComponent } from './scheduling.component';
import { SchedulerComponent } from './scheduler/scheduler.component';
import { SchConfigComponent } from './sch-config/sch-config.component';
import { TravelRequestComponent } from './travel-request/travel-request.component';
import { TravelDashboardComponent } from './travel-request/travel-dashboard/travel-dashboard.component';
import { TravelOrphanedComponent } from './travel-request/travel-orphaned/travel-orphaned.component';
import { TravelOpenendedComponent } from './travel-request/travel-openended/travel-openended.component';
import { TravelAwaitingComponent } from './travel-request/travel-awaiting/travel-awaiting.component';
import { TravelUnconfirmedComponent } from './travel-request/travel-unconfirmed/travel-unconfirmed.component';
import { SchedulerActionRequiredComponent } from './scheduler-action-required/scheduler-action-required.component';
import { TravelApprovalComponent } from './travel-request/travel-approval/travel-approval.component';
import { ScheduleApprovalComponent } from './schedule-approval/schedule-approval.component';
import { AuthGuard } from '../../../../src/app/guards/auth.guard';

const schedulingRoutes: Routes = [
  {
    path: "",
    component: SchedulingComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        children: [
          { path: './', redirectTo: "", pathMatch: "full" },
          { path: '', component: SchedulerComponent },
          { path: 'schConfig', component: SchConfigComponent },
          { path: 'travelDashboard', component: TravelDashboardComponent },
          { path: 'travelApproval', component: TravelApprovalComponent },
          { path: 'travelOrphaned', component: TravelOrphanedComponent },
          { path: 'travelOpenended', component: TravelOpenendedComponent },
          { path: 'travelAwaiting', component: TravelAwaitingComponent },
          { path: 'travelUnconfirmed', component: TravelUnconfirmedComponent },
          { path: 'siAwaitingApproval', component: ScheduleApprovalComponent },
          { path: 'schrActionRequired', component: SchedulerActionRequiredComponent},
          { path: 'travelRequest', component: TravelRequestComponent },
          { path: 'travelRequest/:trId', component: TravelRequestComponent },
          { path: 'travelRequest/:trId/:siId', component: TravelRequestComponent },
          { path: ':siId', component: SchedulerComponent }
        ]
      }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(schedulingRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SchedulingRoutingModule { }
